export default __webpack_public_path__ + "static/media/DisableComplaints.5fd46651.svg";